import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../components/Converter";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";

function WanddickeUebergangsrohr({ wanddickeUebergangsrohr = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.minWallThicknessTransitionPipe")}</p>}
      indicesValue={
        <span>
          t<sub>min</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(wanddickeUebergangsrohr, 1)}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default WanddickeUebergangsrohr;
